
import { Icon } from "@iconify/react";

const WhatsAppIcon = () => (
    <>
        <a
            href="https://wa.me/919995159567?text=Hello%20There..!"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                backgroundColor: "#25D366", // WhatsApp green color
                padding: "12px",
                borderRadius: "50%",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
                transition: "transform 0.3s ease-in-out", // Animation properties
                transformOrigin: "center center",
            }}
            className="whatsapp-icon"
        >
            <Icon icon="mdi:whatsapp" style={{ fontSize: "40px", color: "#fff", transition: "transform 0.3s ease-in-out" }} />
        </a>
    </>
);

export default WhatsAppIcon;
